import React from 'react'
import Home from '../Pages/Home';
import SubNav from "../Common/SubNav"
import Footer from '../Common/Footer';


const Dashboard = (props) => {
    const { isShow, setIsShow } = props;
    return (
        <div className='h-screen w-full overflow-auto responsive_small'>
            <SubNav isShow={isShow} setIsShow={setIsShow} />
            <div className='h-full w-full'>
                <div className='w-full '>
                    <Home
                        isShow={isShow}
                        setIsShow={setIsShow}
                    />
                </div>
                <Footer />
            </div>
        </div>
    )
}

export default Dashboard;